import Press from "~/components/Press/Press";
const PagePress = Press

export async function getServerSideProps(context: any) {

  let page = 0
  let webview = 0
  try {
    page = parseInt(context.req.query.page)
    webview = context.req.query.webview || 0
  } catch (ex) {

  }
  const url = `https://djemclypbm8gi.cloudfront.net/static/files/press.json?ver=${Math.random()}`
  const press = await fetch(url).then(res => res.json())

  return {
    props: {
      press,
      defaultPage: page - 1,
      webview
    }, // will be passed to the page component as props
  }
}


export default PagePress
